import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledBackstageIconLinkVertical = (
  theme: Theme,
): BackstageOverrides['BackstageIconLinkVertical'] => ({
  link: {
    justifyItems: 'center',
    minWidth: theme.spacing(9),
    overflowWrap: 'normal',
    textAlign: 'center',
    wordBreak: 'normal',
  },
  label: {
    display: 'block',
    letterSpacing: 0,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },
});
